import React from "react";
import { Link } from "gatsby"
import "./logo.scss";
import classNames from "classnames";
import { useStaticQuery, graphql } from "gatsby"

export const Logo = (props) => {
    const myQuery = useStaticQuery(query);
    const config = myQuery.site.siteMetadata.config;
    const classnames = classNames("logo", {
        "e-logo--mobile": props.mobile,
    });

    return (
        <>
        <div className={props.className ? props.className + ` ` + classnames : classnames}>
            <Link to={`/`}>
                <img src={`/${config.country}/logo.svg`} alt={config.site_name}/>
            </Link>
        </div>
        </>
    );
};

const query = graphql`
  query Config {
    site {
      siteMetadata {
        config {
          country
          site_name
        }
      }
    }
  }
`;